export enum Environment {
  Localhost = 'Localhost',
  Development = 'Development',
  Staging = 'Staging',
  Production = 'Production',
}
